import React from "react";
import "../InvoicingIATA.css";
import NoDataPlaceholder from "../../../../components/element/NoDataPlaceholder";
import Loader from "../../../../components/element/Loader";
import ErrorPopup from "../../../../components/element/ErrorPopup";
import { formatToTwoDecimal, handleEmptyValue } from "../../../../utils/utils";
import { DATE_FORMAT, PAYMENT_METHOD_TYPE } from "../../../../utils/constants";
import dayjs from "dayjs";
import { Button } from "@mui/material";

const NewInvoicingIATATable = ({
  invoicingData,
  isLoading,
  error,
  onClickView,
}) => {
  const uniqueInvoices = [
    ...new Map(
      invoicingData?.map((item) => [item?.billingDocument, item])
    ).values(),
  ];

  if (error) {
    if (error.status === 404) {
      return <NoDataPlaceholder />;
    } else {
      return <ErrorPopup children={error.message}></ErrorPopup>;
    }
  }

  if (isLoading) {
    return <Loader />;
  }

  if (invoicingData && invoicingData.length === 0) {
    return <NoDataPlaceholder />;
  }

  return (
    <div className="invoicing-IATA-table-parent-container">
      <div className="invoicing-IATA-table-container">
        <table className="invoicing-IATA-table">
          <thead>
            <tr>
              <th>No.</th>
              <th>Billing Document</th>
              <th>Client Invoice Ref Number</th>
              <th>Billing Date</th>
              <th>Payment Method</th>
              <th>Airline Name</th>
              <th>Billing Currency</th>
              <th>Billing Amount Before Tax</th>
              <th>Tax Amount</th>
              <th>Billing Amount After Tax</th>
              <th>AA Invoice Number</th>
              <th>Invoice Date</th>
              <th>View Invoice</th>
            </tr>
          </thead>
          <tbody>
            {uniqueInvoices?.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{handleEmptyValue(item?.billingDocument)}</td>
                <td>{handleEmptyValue(item?.clientInvoiceReference)}</td>
                <td>{dayjs(item?.billingDate).format(DATE_FORMAT)}</td>
                <td>{PAYMENT_METHOD_TYPE.find(
                  (type) => type.value === item?.paymentMethod
                )?.name}</td>
                <td>{handleEmptyValue(item?.airlineName)}</td>
                <td>{handleEmptyValue(item?.billingCurrency)}</td>
                <td>{formatToTwoDecimal(item?.billingAmountBeforeTaxTotal)}</td>
                <td>{formatToTwoDecimal(item?.taxAmountTotal)}</td>
                <td>{formatToTwoDecimal(item?.billingAmountAfterTaxTotal)}</td>
                <td>{handleEmptyValue(item?.dynamicsInvoiceNumber)}</td>
                <td>{dayjs(item?.invoiceDate).format(DATE_FORMAT)}</td>
                <td>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => onClickView(item)}
                  >
                    View
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default NewInvoicingIATATable;
